import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Municipio } from '../../../../../shared/models/response/localidade.model';
import { CardCollapseComponent } from '../../../../../shared/components/collapse/card-collapse.component';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { CommonModule } from '@angular/common';
import { TableFilterBarComponent } from '../../../../../shared/components/table-filter-bar/table-filter-bar.component';
import { CadastroReservaMunicipio } from '../../../../../shared/models/response/cadastro-reserva-municipio.model';
import { LoadingService } from '../../../../../shared/services/loading.service';
import { CadastroReservaMunicipioService } from '../../../../../shared/services/cadastro-reserva-municipio.service';

@Component({
  selector: 'app-resumo-confirmacao-print',
  imports: [CardCollapseComponent, CommonModule, TableFilterBarComponent],
  templateUrl: './resumo-confirmacao-print.component.html',
  styleUrl: './resumo-confirmacao-print.component.scss',
})
export class ResumoConfirmacaoPrint implements OnInit {
  @Input() municpio!: Municipio;
  @Input() confirmacaoVaga: any;
  @Input() cadastrosReservaMunicipio: CadastroReservaMunicipio[] = [];
  @Input() modalRef: any;
  @Input() data: any[] = [];
  @Input() resumoVagas: any[] = [];
  @Input() totalVagasConfirmadas: number = 0;
  @ViewChild('printSection') printSection!: any;

  private readonly loadingService = inject(LoadingService);
  private readonly cadastroReservaMunicipioService = inject(
    CadastroReservaMunicipioService,
  );
  private readonly cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.initialize().then(() => {
      setTimeout(() => {
        this.print();
        this.modalRef.close();
      }, 100);
    });
  }

  print(): void {
    const pages = document.querySelector('#printSection') as HTMLElement;

    let pdf = new jsPDF({
      unit: 'px',
      format: [210, 297],
    });
    pdf.html(pages, {
      callback: (pdf: jsPDF) => {
        pdf.save('resumo-confirmacao.pdf');
      },
      html2canvas: {
        scale: 0.25,
      },
      margin: [5, 5, 5, 5],
      autoPaging: 'text',
    });
  }

  private async initialize(): Promise<void> {
    return new Promise(async (resolve) => {
      if (this.confirmacaoVaga) {
        await this.loadReserva(this.confirmacaoVaga.ciclo.id);
      } else {
        this.confirmacaoVaga = {
          ciclo: this.cadastrosReservaMunicipio[0]?.ciclo,
          municipio: this.cadastrosReservaMunicipio[0]?.municipio,
          usuario: this.cadastrosReservaMunicipio[0]?.usuario,
        };
      }

      resolve();
    });
  }

  private loadReserva(cicloId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.loadingService.open();
      this.cadastroReservaMunicipioService
        .fetchByMunicipioAndCiclo(this.municpio?.id as string, cicloId)
        .subscribe({
          next: (cadastros: CadastroReservaMunicipio[]) => {
            this.loadingService.close();
            this.cadastrosReservaMunicipio = cadastros;
            // Handle reserva data as needed
            this.cdr.detectChanges();
            resolve();
          },
          error: (error) => {
            this.loadingService.close();
            reject();
          },
        });
    });
  }
}
